/** Browser session — phone_token (v1: family_token from dev also accepted until Pair ships). */

const TOKEN_KEY = 'remindo_phone_token';

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function hasToken(): boolean {
  return Boolean(getToken());
}

/** DevLab: ?token=... in URL stores and strips query. */
export function consumeTokenFromQuery(): void {
  const url = new URL(window.location.href);
  const t = url.searchParams.get('token') ?? url.searchParams.get('phone_token');
  if (!t) return;
  setToken(t);
  url.searchParams.delete('token');
  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
}
